import styled from 'styled-components';
import { Button } from 'antd';

export const ChangeButton = styled<any>(Button)`
  border: 0;
  text-transform: uppercase;
  font-size: 12px;
  margin: 0 10px;
`;
